// Assignment Notification Service
// Handles notifications when leads are assigned to employees

class AssignmentNotificationService {
  constructor() {
    this.STORAGE_KEY = 'assignment_notifications';
  }

  // Create a new assignment notification
  createNotification(leadData, employeeId, employeeName) {
    const notification = {
      id: `notif_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`,
      leadId: leadData._id,
      leadName: leadData.customerName || leadData.name,
      leadEmail: leadData.email,
      leadType: leadData.leadType,
      serviceType: leadData.serviceType,
      employeeId: employeeId,
      employeeName: employeeName,
      assignedAt: new Date().toISOString(),
      read: false,
      type: 'lead_assignment'
    };

    // Get existing notifications
    const notifications = this.getAllNotifications();
    
    // Add new notification
    notifications.push(notification);
    
    // Save to localStorage
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(notifications));
    
    console.log('📬 Assignment notification created:', notification);
    
    // Dispatch custom event for real-time notification
    window.dispatchEvent(new CustomEvent('newAssignmentNotification', {
      detail: notification
    }));
    
    return notification;
  }

  // Get all notifications
  getAllNotifications() {
    try {
      const data = localStorage.getItem(this.STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (error) {
      console.error('Error getting notifications:', error);
      return [];
    }
  }

  // Get notifications for specific employee
  getNotificationsForEmployee(employeeId) {
    const allNotifications = this.getAllNotifications();
    return allNotifications.filter(n => n.employeeId === employeeId);
  }

  // Get unread notifications for employee
  getUnreadNotifications(employeeId) {
    const employeeNotifications = this.getNotificationsForEmployee(employeeId);
    return employeeNotifications.filter(n => !n.read);
  }

  // Mark notification as read
  markAsRead(notificationId) {
    const notifications = this.getAllNotifications();
    const notification = notifications.find(n => n.id === notificationId);
    
    if (notification) {
      notification.read = true;
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(notifications));
      console.log('✅ Notification marked as read:', notificationId);
    }
  }

  // Mark all notifications as read for employee
  markAllAsRead(employeeId) {
    const notifications = this.getAllNotifications();
    notifications.forEach(n => {
      if (n.employeeId === employeeId) {
        n.read = true;
      }
    });
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(notifications));
    console.log('✅ All notifications marked as read for employee:', employeeId);
  }

  // Delete notification
  deleteNotification(notificationId) {
    let notifications = this.getAllNotifications();
    notifications = notifications.filter(n => n.id !== notificationId);
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(notifications));
    console.log('🗑️ Notification deleted:', notificationId);
  }

  // Clear old notifications (older than 7 days)
  clearOldNotifications() {
    const notifications = this.getAllNotifications();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    
    const recentNotifications = notifications.filter(n => {
      const notifDate = new Date(n.assignedAt);
      return notifDate > sevenDaysAgo;
    });
    
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(recentNotifications));
    console.log('🧹 Old notifications cleared');
  }
}

export default new AssignmentNotificationService();
